import { BuildingCompany } from './building-company.model';

export class BuildingCompanyMany {
  buildingCompanies: BuildingCompany[];
}
